(function () {
  // Variables globales
  const productVariants = CurrentProduct;
  const templateName = CurrentTemplate;
  const selectedOptions = { color: null, size: null };
  const getUrl = window.location;
  const variantColorEls = document.querySelectorAll('.variant_color');
  const variantSizeEls = document.querySelectorAll('.variant_size');
  const colorSelectedEl = document.querySelector('.color-selected');
  const sizeSelectedEl = document.querySelector('.size-selected');
  const productSelectEl = document.querySelector('#ProductSelect');
  const addToCartBtn = document.querySelector('#AddToCartBtnBsl');

  // Funtions
  async function addToCartClickHandler(event) {
    const bodyElement = document.querySelector('body');
    const drawerCart = document.querySelector('#drawer-cart-modal')
    event.preventDefault();
    const form = event.target.parentNode;
    const formData = new FormData(form);
    try {
      const response = await fetch('/cart/add.js', {
        method: 'POST',
        body: formData
      });
      await response.json();
      liquidAjaxCart.update();
      bodyElement.style.overflow = 'hidden';
      drawerCart.classList.add('show-cart-modal');
      
    } catch (error) {
      console.log(error);
    }
  }
    
  function handleClick(event) {
    event.preventDefault();

    event.preventDefault();

    const button = event.currentTarget;
  
    const optionName = button.getAttribute('data-name');
    const optionValue = button.getAttribute('value');
    const onlyLeftInStock = document.querySelector('#only-left-in-stock');
    selectedOptions[optionName] = optionValue;

    const selectedVariant = getProductVariant(productVariants, selectedOptions);

    addRemoveClass(`.variant_${optionName}`, button, 'selected');
    updateSizeAvailability();
    if (selectedVariant) {
      colorSelectedEl.textContent = selectedVariant.options[0];
      
      mainContainerColor(colorSelectedEl.textContent)
      sizeSelectedEl.textContent = selectedVariant.options[1];
      productSelectEl.value = selectedVariant.id;
      

      if (selectedVariant.inventory_quantity > 0 && selectedVariant.inventory_quantity <= 10) {
        onlyLeftInStock && onlyLeftInStock.classList.add('show-only-left');
        onlyLeftInStock && onlyLeftInStock.classList.remove('dn-i')
        if (onlyLeftInStock != null) onlyLeftInStock.textContent = `Only ${selectedVariant.inventory_quantity} left!`
      } else {
        onlyLeftInStock && onlyLeftInStock.classList.add('dn-i', 'show-only-left')
      }
      const variantUrl = getUrl.search.split('nosto=').pop();
      if (!variantUrl) {
        history.pushState(null, 'Title', `${getUrl.pathname}?variant=${selectedVariant.id}`);
      }

      const soldButton = document.querySelector('.sold-out-btn');
      const backInStock = document.querySelector('.pdp-klaviyo-trigger')
      let showRealPrice = document.querySelectorAll('.info-product-detail__pdp-price');
      if (selectedVariant.available) {
        UpdatePriceVariant('.info-product-detail__pdp-price', selectedVariant.price);
        let showComparePrice = document.querySelectorAll('.info-product-detail__pdp-compare-at-price');
    
          if (selectedVariant.compare_at_price > selectedVariant.price) {
              UpdatePriceVariant('.info-product-detail__pdp-compare-at-price', selectedVariant.compare_at_price);  
              [...showComparePrice].forEach(item => item.classList.remove('dn-i'));
              [...showRealPrice].forEach(item => item.classList.add('fc-red-lt'));
          }else{
              [...showComparePrice].forEach(item => item.classList.add('dn-i'));
              [...showRealPrice].forEach(item => item.classList.remove('fc-red-lt'));
          }

        addToCartBtn.disabled = false;
        addToCartBtn.classList.remove('dn-i')
        addToCartBtn.classList.remove('disabled-add-to-cart');
        history.replaceState(null, 'Title', `${getUrl.pathname}?variant=${selectedVariant.id}`);
        soldButton.classList.add('dn-i')
        backInStock.classList.add('dn-i');
      } else {
        history.replaceState(null, 'Title', `${getUrl.pathname}?variant=${selectedVariant.id}`);
        addToCartBtn.disabled = true;
        addToCartBtn.classList.add('disabled-add-to-cart');
        soldButton.classList.remove('dn-i');
        backInStock.classList.remove('dn-i');
        addToCartBtn.classList.add('dn-i');
        [...showRealPrice].forEach(item => item.classList.remove('fc-red-lt'));
      }
      
    }
  }

  function getProductVariant(product, selectedOptions) {
    const variantOptionCurrent = productSelectEl.selectedOptions[0].dataset.variantOptions.split('-');
    const colorSelected = selectedOptions.color || variantOptionCurrent.shift();
    const sizeSelected = selectedOptions.size || variantOptionCurrent.pop();
    const matchText = `${colorSelected} / ${sizeSelected}`;

    const selectedVariant = product.variants.find(variant => variant.title === matchText);
    UpdatePriceVariant('.info-product-detail__pdp-price', selectedVariant.price);
    let showComparePrice = document.querySelectorAll('.info-product-detail__pdp-compare-at-price');

      if (selectedVariant.compare_at_price > selectedVariant.price) {
          UpdatePriceVariant('.info-product-detail__pdp-compare-at-price', selectedVariant.compare_at_price);  
          [...showComparePrice].forEach(item => item.classList.remove('dn-i'));
      }else{
          [...showComparePrice].forEach(item => item.classList.add('dn-i'));
      }
      
    return selectedVariant;
  }

  function setDefaultVariant() {
    const variantUrl = getUrl.search.split('?variant=').pop();
    const selectedOptions = document.querySelectorAll('.swatch-btn[selected]');
    const availableVariants = productSelectEl.querySelectorAll('option');

    if (variantUrl && [...availableVariants].some(v => v.value === variantUrl)) {
      productSelectEl.value = variantUrl;
      document.querySelector('.variant_size.selected') && document.querySelector('.variant_size.selected').click();
      history.replaceState(null, 'Title', `${getUrl.pathname}?variant=${variantUrl}`);
    }
    if (selectedOptions) selectedOptions.forEach(option => option.click());

  }

  //Availables variants size
  function updateSizeAvailability() {
    const color = selectedOptions.color;
    const unavailableSizes = new Array();
    const availableSizes = new Array();

    variantSizeEls.forEach(sizeEl => {
      const sizeValue = sizeEl.getAttribute('value');
      const variant = getProductVariant(productVariants, { color: color, size: sizeValue });

      sizeEl.dataset.colorSelected = color;
      colorSelectedEl.dataset.colorSelected = color;
      availableSizes.push(sizeValue)
      if (variant && variant.available) {
        sizeEl.classList.remove('sold-out');
      } else {
        sizeEl.classList.add('sold-out');
        unavailableSizes.push(sizeValue);
      }

      sizeEl.textContent = cutTheTextContent(sizeEl.dataset.cuttext);
    });
  }

  function initProductVariants() {
    variantColorEls.forEach(variantColorEl => variantColorEl.addEventListener('click', handleClick));
    variantSizeEls.forEach(variantSizeEl => variantSizeEl.addEventListener('click', handleClick));
  }

  function mainContainerColor(color) {
    const mainContainersColor = document.querySelectorAll('.gallery-main-media');
    const colorSelected = color.replace(/\s+/g, '-').toLowerCase();
    [...mainContainersColor].forEach(mainContainer => {
      mainContainer.classList.add('dn-i');
      
      if (mainContainer.classList.value.includes(colorSelected)) {
        mainContainer.classList.remove('dn-i');
      }
    
    });
  }

  //Render Gallerty tags
  function renderGalleryTags() {
    const tagsContainers = Array.from(document.getElementsByClassName('image-gallery-tag'));
    
    tagsContainers.forEach(tagEle => {
        tagEle.addEventListener('click', () => {

          const tagButton =  tagEle.querySelector('.image-gallery-tag__icon');
          const tagText = tagEle.querySelector('.image-gallery-tag__text');    
              tagButton.classList.toggle('hide-elem')
              tagText.classList.toggle('hide-elem')
        });
    });


  }
  function accordions() {
    const accordion = document.querySelectorAll('.accordion-pdp');
    [...accordion].forEach((singleAccordion, index) => {
      singleAccordion.addEventListener('click', () => {
        singleAccordion.classList.toggle('active-pdp');
        const panel = singleAccordion.nextElementSibling;
        if (panel.style.maxHeight) {
          panel.style.maxHeight = null;
        } else {
          panel.style.maxHeight = panel.scrollHeight + "px";
        }

      });
    });
  }
//Helpers

  function addRemoveClass(optionName, selected, active) {
    let container = document.querySelectorAll(optionName);
    [...container].forEach(item => {
      item.classList.remove(active);
    });
    selected.classList.add(active)
  }
  function UpdatePriceVariant(items, price) {
    let container = document.querySelectorAll(items);

    [...container].forEach(item => {
      return item.innerHTML = `${window.currencySymbol}${(price / 100).toFixed(2)}`;
    });
  }
  function cutTheTextContent(textContent) {
    var decimal = /^[+-]?\d+(\.\d+)?$/;
    if (textContent.includes('/')) return textContent;
    if (textContent.includes('$')) return textContent.slice(0, -3);
    if (decimal.test(textContent)) return textContent;
    return textContent.replace(/[^A-Z]/g, '')
  }

  function removeAccordionEmpty() {
    [...document.querySelectorAll('.accordion-content')].forEach(item => {
      if ([...item.children].length == 0) {
        item.classList.add('dn-i')
      }
    })
  }

  if (!addToCartBtn) return;

  initProductVariants();

  setDefaultVariant();
  accordions();
  renderGalleryTags()
  removeAccordionEmpty();

  addToCartBtn.addEventListener('click', addToCartClickHandler);


})();

function UdapteContainerIfHeaderSticky(params) {
  let headerDiv = document.querySelector('#header');
  let stickyContainer = document.querySelector('.main-container-pdp .info-container')
  
  if (headerDiv.classList.contains('stuck') && headerDiv.classList.contains('tuck') && headerDiv.classList.contains('untuck')){
    stickyContainer.style.top = '115px';
  }else{
    stickyContainer.style.top = '5px';
  }

}

document.addEventListener("scroll", UdapteContainerIfHeaderSticky);

//utility functions
function waitForElement(selector) {
  return new Promise(resolve => {
    const element = document.querySelector(selector);
    if (element) {
      return resolve(element);
    }
    
    const observer = new MutationObserver(mutations => {
      const element = document.querySelector(selector);
      if (element) {
        resolve(element);
        observer.disconnect();
      }
    });
    
    observer.observe(document.body, {
      childList: true,
      subtree: true
    });
  });
}

function renderYotpoRatingCount() {
  let yotpoRatings = document.querySelectorAll('.card-related-product__content-rating .yotpo-bottomline .text-m');
    
  [...yotpoRatings].forEach(rating => {
    let cutTextRating = rating.getAttribute('aria-label').split(' ').shift();
        rating.textContent = `(${cutTextRating})`;
  })
}

waitForElement('.standalone-bottomline .yotpo-stars').then((elm) => {
  setTimeout(renderYotpoRatingCount, 2000); 
});


//modal size 
function openCloseModalG(modal, action) {
  const sizeChart = document.querySelector(modal);
  if (action) sizeChart.classList.add('size-chart-show')
  if (!action) sizeChart.classList.remove('size-chart-show')
}


function hideElementOnEsc(elementSelector, keyCode, classNameToAdd, isAdd, carousel) {
  const element = document.querySelector(elementSelector);

  if (!element) {
    console.error(`Element not found with selector: ${elementSelector}`);
    return;
  }

  document.addEventListener('keydown', function (event) {
    if (event.keyCode === keyCode) {
      if (!element.classList.contains(classNameToAdd && isAdd)) {
        if (isAdd) element.classList.add(classNameToAdd);
        document.querySelector('body').style.overflow = 'auto';
      }

      if (element.classList.contains(classNameToAdd) && !isAdd) {
        element.classList.remove(classNameToAdd);
        document.querySelector('body').style.overflow = 'auto';
        if ($(carousel).hasClass('slick-initialized')) {
          $(carousel).slick('unslick');
        }
      }

    }
  });
}

waitForElement('.container-infinite').then((elm) => {
  hideElementOnEsc('.container-infinite', 27, 'dn-i', true);
});

waitForElement('.zoom-gallery_container').then((elm) => {
  hideElementOnEsc('.zoom-gallery_container', 27, 'dn-i', true);
});

waitForElement('.size-chart-acf__modal').then((elm) => {
  hideElementOnEsc('.size-chart-acf__modal', 27, 'dn-i', true);

});
